export type MetricGroup = {
  metricGroupName: string
  metricGroupNameDatakey: string
  metrics: ({
    metricName: string
    metricValue: MetricValue
    multiplier: number
  } & Record<string, string | number>)[]
  multiplier: number
  metricScore?: number
  metricList?: {
    absolute: Record<string, string | number>[]
    perCapita: Record<string, string | number>[]
  }
} & Record<string, any>

export type Country = {
  countryName: string
  countryCode: string
  countryLongCode: string
  metadatas: Record<string, string | number>[]
  ranking?: number
  totalAverage?: number
  economyShare?: number
  researchShare?: number
  totalMetricUsed?: number
  shareSum?: number
  economyTotal?: number
  researchTotal?: number
  metricsData?: Record<string, string | number | unknown>[]
  researchWeight?: number
  economyWeight?: number
  totalScore?: number
} & Record<string, string | number | unknown>

export type DataKey =
  | 'research'
  | 'economy'
  | 'education'
  | 'diversity'
  | 'policy'
  | 'publicOpinion'
  | 'responsible'
  | 'infrastructure'

export enum SortOrder {
  overallPosition = 'Overall Positioning',
  groupByPillar = 'Pillar Grouping',
}

export type BarChartGlobalData = {
  name: string
  score: number
  countryName: string
  countryCode: string
  countryLongCode: string
  id: number
  research: number
  economy: number
  researchWeight?: number
  economyWeight?: number
}[]

export type BarChartNationalData = {
  metricName: string
  metricNameRaw: string
  metricValue: MetricValue
  pillar: string
  variableName: string
  variableNameRaw: string
  score: number
  countryName: string
  id: number
}[]

export type BarChartNationalRankedData = {
  id: number
  score: number
  countryName: string
  cRank?: number
}[]

export type SlopeData = ({
  year: string
} & Record<string, number | string>)[]

export type MetricValue = 'perCapita' | 'absolute'
export type ViewType = 'bar' | 'table' | 'slope'
export type ChartType = 'bar' | 'map' | 'indicator' | 'country'

export type Ranking = 'global' | 'national' | 'subindices'
export type MetricType = 'rad' | 'eco' | 'edu' | 'div' | 'pol' | 'pub' | 'rai' | 'inf'
export interface IMetric {
  absolute: string
  perCapita: string
}
export interface IGlobalState {
  tool?: 'AIVR' | 'AIMOT'
  ranking?: Ranking
  country: string
  countryType: Ranking
  comparingCountries?: Array<string>
  metric: {
    rad: IMetric
    eco: IMetric
    edu: IMetric
    div: IMetric
    pol: IMetric
    pub: IMetric
    rai: IMetric
    inf: IMetric
  }
  metricType: MetricType
  metricValue: MetricValue
  chartType: ChartType
  worldmapYear: number
}

export type ArrElement<ArrType> = ArrType extends readonly (infer ElementType)[] ? ElementType : never
export interface InputDataProps {
  year: string
  value: any
}
export interface BarChartProps {
  data: InputDataProps[]
  height: number
  barColor?: string
  activeBarColor?: string
  barWidth?: number
  axisFontSize?: number
  isGrid?: boolean
  gridBackground?: string
  gridColor?: string
  isTickLine?: boolean
  tickColor?: string
  tickCount?: number
  showPercentage?: boolean
}
export interface WorldmapChartProps {
  data: InputDataProps[]
}
export interface CountryData {
  countryName: string
  countryCode: string
  countryLongCode: string
}
export interface DownloadProps {
  handleDownPNG: Function
  handleDownJPG: Function
  handleDownPDF: Function
}
export type DownloadType = 'jpg' | 'png' | 'pdf' | null

export type SimplifyMetricGroup = Array<{
  metricName: string
  metricShortName: string | number
  metricShortNameScaled: string | number
  multiplier: number
}>
export interface ReportOverViewDataProps {
  countryReportData: Country | undefined
  totalCountry: number
}
